import { useState, useEffect } from "react";
import { getDocs, collection } from "firebase/firestore";
import { merge } from "lodash";
import ReactApexChart from "react-apexcharts";
import { Card, CardHeader, Box } from "@mui/material";
import { BaseOptionChart } from "../../../components/charts";
import { db } from "../../../firebase";

export default function AppWebsiteVisits() {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "subscriptions"));
        const subscriptionData = querySnapshot.docs.map(doc => doc.data().value); // Assuming each document has a 'value' field
        setData(subscriptionData);
      } catch (error) {
        console.error("Error fetching subscriptions data:", error);
      }
    };

    fetchData();
  }, []);

  const chartData = [
    {
      name: "Subscribers",
      type: "column",
      data,
    },
  ];

  const chartOptions = merge(BaseOptionChart(), {
    stroke: { width: [0, 2, 3] },
    plotOptions: { bar: { columnWidth: "11%", borderRadius: 4 } },
    fill: { type: ["solid", "gradient", "solid"] },
    labels: [
      "01/01/2022",
      "02/01/2022",
      "03/01/2022",
      "04/01/2022",
      "05/01/2022",
      "06/01/2022",
      "07/01/2022",
      "08/01/2022",
      "09/01/2022",
      "10/01/2022",
      "11/01/2022",
    ],
    xaxis: { type: "datetime" },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== "undefined") {
            return `${y.toFixed(0)} new members`;
          }
          return y;
        },
      },
    },
  });

  return (
    <Card>
      <CardHeader title="Monthly Subscriptions" subheader="(+43%) than last year" />
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart type="line" series={chartData} options={chartOptions} height={364} />
      </Box>
    </Card>
  );
}
